var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"colorWhite"},[_c('div',{staticClass:"displayInLineBlock pl-5"},[_c('h3',[_vm._v(_vm._s(_vm.$store.getters.title)+" / "+_vm._s(_vm.$store.getters.subtitle))])]),_c('div',{staticStyle:{"float":"right"}},[_c('div',{staticStyle:{"width":"525px"}},[_c('b',[_vm._v(_vm._s(_vm.employee_name))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }